import { jsx as _jsx } from "react/jsx-runtime";
export const AudioTag = ({ audioRef, muteAudio }) => {
    return (_jsx("audio", { ref: audioRef, style: { display: "none" }, autoPlay: true, muted: muteAudio }));
};
